import React from 'react';
import styles from './HomeTorneosLayout.module.css';

const HomeTorneosLayout = ({ variant = 'singleColumn', className = '', children }) => {
  return <div className={`${styles.base} ${styles[variant]} ${className}`.trim()}>{children}</div>;
};

export default HomeTorneosLayout;
